export function shuffle<T> (array: T[]) {
  for (let i = array.length - 1; i >= 0; i--) {
    // 0~iのランダムな数値を取得
    const rand = Math.floor(Math.random() * (i + 1));

    // 配列の数値を入れ替える
    [array[i], array[rand]] = [array[rand], array[i]]
  }
  return array
}

export function randomChoise<T> (array: T[]) {
  const index = Math.floor(Math.random() * array.length)
  return array[index]
}
